import React, { useContext } from 'react'
import { adMentorAI } from '../assets/images'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../context/UserContext'

const FooterComponent = () => {
  const {setActiveUrl} = useContext(UserContext)
  const navigate = useNavigate()

  const handleNavigation = (url) => {
    setActiveUrl(url)
    navigate(url)  
  }
  return (
    <>
      <footer className="bg-white border-t mt-20 text-gray-700">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <img src={adMentorAI} alt='ad mentor ai logo' className='w-40 mb-2' />
          <p className="text-sm">The AI-powered advertising optimization platform to scale your campaigns with smart suggestions and real-time insights.</p>
        </div>

        <div>
          <h3 className="font-semibold text-sm mb-3">Product</h3>
          <ul className="space-y-2 text-sm">
            <li onClick={()=>handleNavigation('/features')} className="cursor-pointer hover:text-blue-600">Features</li>
            <li onClick={()=>handleNavigation('/pricing')} className="cursor-pointer hover:text-blue-600">Pricing</li>
            <li onClick={()=>handleNavigation('/dashboard')} className="cursor-pointer hover:text-blue-600">Dashboard</li>
            <li className="cursor-pointer hover:text-blue-600">Integrations</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-sm mb-3">Company</h3>
          <ul className="space-y-2 text-sm">
            <li onClick={()=>handleNavigation('/about-us')} className="cursor-pointer hover:text-blue-600">About Us</li>
            <li onClick={()=>handleNavigation('/careers')} className="cursor-pointer hover:text-blue-600">Careers</li>
            <li onClick={()=>handleNavigation('/contact')} className="cursor-pointer hover:text-blue-600">Contact</li>
            <li className="cursor-pointer hover:text-blue-600">Blog</li>
          </ul>
        </div>

        <div>
          <h3 className="font-semibold text-sm mb-3">Get in Touch</h3>
          <ul className="space-y-2 text-sm">
            <li>Email: support@admentorai.com</li>
            <li>Phone: +91 98765 43210</li>
            <li>Address: Mumbai, India</li>
            <li className="flex space-x-4 mt-2">
              <span className="cursor-pointer hover:text-blue-600">LinkedIn</span>
              <span className="cursor-pointer hover:text-blue-600">Twitter</span>
              <a rel="noreferrer" href='https://instagram.com/admentorai' target='_blank' className="cursor-pointer hover:text-blue-600">Instagram</a>
            </li>
          </ul>
        </div>
      </div>
      <div className='px-4 text-sm flex justify-between items-center'>
        <p className='cursor-pointer text-gray-600' onClick={()=>navigate("/terms-and-service")}>Terms and conditions</p>
        <div className="text-center text-sm text-gray-500 py-4 border-t">
          © {new Date().getFullYear()} AdMentorAI. All rights reserved.
        </div>
        <p className='cursor-pointer text-gray-600' onClick={()=>navigate("/privacy-policy")}>Privacy policy</p>
      </div>
    </footer>
    </>
  )
}

export default FooterComponent